module.exports = __webpack_public_path__ + "static/img/title.e90dfbfd.jpg";